export const parseHeaders = (headersString: string) => {
  try {
    return JSON.parse(headersString)
  } catch {
    return {}
  }
}
